<ng-template
    #imageuploaderboxRef
    let-imageFile="imageFile"
    let-imagePath="imagePath"
>
    <div class="imageuploaderbox" *ngIf="!imagePath">
        <div class="imageuploaderbox-link">
            <i class="material-icons imageuploaderbox-icon"> cloud_upload </i>

            <form>
                <div class="form-group">
                    <label for="{{ imageFile }}">Επιλέξτε Φωτογραφία</label>
                    <input
                        type="file"
                        class="form-control-file d-none"
                        id="{{ imageFile }}"
                        (change)="changeHandler($event)"
                    />
                </div>
            </form>
        </div>
        <div class="imageuploaderbox-specs">
            <span> Μέγιστο μέγεθος: Χ ΜΒ </span>
            <span> Τύπος αρχείου: .JPG, .PNG, .JPEG </span>
        </div>
    </div>
    <div class="imageuploaderpreview" *ngIf="imagePath">
        <div class="imageuploaderpreview-placeholder">
            <img
                *ngIf="imagePath"
                [src]="imagePath"
                alt="Preview"
                class="imageuploaderpreview-preview"
            />
        </div>
        <div class="imageuploaderpreview-specs">
            <span> Ημερομηνία: 19/09/2020 </span>
            <span> Μέγεθος: 11ΜΒ </span>
        </div>
    </div>
</ng-template>

<ng-template> </ng-template>

<div class="row">
    <div class="col">
        <ng-container
            *ngTemplateOutlet="
                imageuploaderboxRef;
                context: {
                    imageFile: 'imageFileProfile',
                    imagePath: imagePathProfile
                }
            "
        >
        </ng-container>
    </div>
    <div class="col">
        <ng-container
            *ngTemplateOutlet="
                imageuploaderboxRef;
                context: {
                    imageFile: 'imageFileSignature',
                    imagePath: imagePathSignature
                }
            "
        >
        </ng-container>
    </div>
</div>
